
export default function AgencyIndex() {
    return (
        <div>
            <h1>Agency Page</h1>
        </div>
    )
}